import { Helmet } from "react-helmet-async";
import { SITE, absUrl } from "../lib/site";

// Per-page head tags: title, description, canonical, Open Graph, Twitter card, robots and JSON-LD.
export const Seo = ({ title, description = SITE.description, path = "/", image = SITE.ogImage, type = "website", noindex = false, jsonLd, published, modified }) => {
  const fullTitle = title ? `${title} · ${SITE.name}` : `${SITE.name} — ${SITE.tagline}`;
  const url = absUrl(path);
  const img = image.startsWith("http") ? image : absUrl(image);
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={SITE.locale} />
      {published && <meta property="article:published_time" content={published} />}
      {modified && <meta property="article:modified_time" content={modified} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {SITE.twitter && <meta name="twitter:site" content={SITE.twitter} />}
      {blocks.map((b, i) => <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>)}
    </Helmet>
  );
};

// Private / session pages: keep them out of search results.
export const NoIndex = ({ title }) => <Seo title={title} noindex />;
